export default "__VITE_ASSET__BsF9s1p$__"